import { useDispatch, useSelector } from "react-redux";
import { alertSelector, alertActions } from "../store/alert-slice";

const useAlert = () => {
  const dispatch = useDispatch();
  const { showAlert, alertMessage, alertColor, alertDismissible } = useSelector(alertSelector);

  const setShowAlert = (bool) => dispatch(alertActions.showAlert(bool));
  const setAlertMessage = (message) => dispatch(alertActions.alertMessage(message));
  const setAlertColor = (color) => dispatch(alertActions.alertColor(color));
  const setAlertDismissible = (bool) => dispatch(alertActions.alertDismissible(bool));

  const createAlert = (message, color, timeout = 5000, dismissible = true) => {
    setAlertMessage(message);
    setAlertColor(color);
    setAlertDismissible(dismissible);
    setShowAlert(true);
    setTimeout(() => {
      setShowAlert(false);
    }, timeout);
  };

  return {
    showAlert,
    alertMessage,
    alertColor,
    alertDismissible,
    setShowAlert,
    setAlertMessage,
    setAlertColor,
    setAlertDismissible,
    createAlert,
  };
};

export default useAlert;
